import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";

// core components
import Snackbars from "components/Snackbar/Snackbar.js";

// Componets
import SelectDateMenu from "components/SelectDateMenu/SelectDateMenu";

import { downloadReport } from "./downloadRequest";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { useSearch } from "hooks/useSearch";
import { dateValidator } from "helpers/dateValidator";

export const ReportPage = () => {
  const dispatch = useDispatch();
  const { 
    changeStartDate, 
    changeEndDate, 
    setSnackbar, 
    clearSnackbar, 
    clearSearch
  } = useSearch();
  
  // selectors
  const { token } = useSelector(state => state.login)
  const { startDate, endDate, color, message, isOpen, isLoading } = useSelector((state) => state.search);



  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if(dateValidator(startDate, endDate, 31, setSnackbar)) return;
    const start = dayjs(startDate).format("YYYY-MM-DD");
    const end = dayjs(endDate).format("YYYY-MM-DD");
    dispatch(downloadReport(start, end, token))
  }, [endDate, startDate, setSnackbar, token, dispatch]);

  useEffect(() => {
    clearSearch()
  }, [clearSearch])

  return (
    <React.Fragment>
      <SelectDateMenu
        dates={{ startDate, endDate }}
        color="info"
        onChangeStartDate={changeStartDate}
        onChangeEndDate={changeEndDate}
        onSubmit={handleSubmit}
        switchState
        handleSwitchChange
        agent={true}
        download={'PDF'}
        topLabel="Seleccione las fechas "
        disabled={isLoading}
      />
      {
        isLoading &&
        <LoadingComponent label="Generando PDF"/>
      }
      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </React.Fragment>
  );
}
